import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Card, CardContent, Typography } from '@mui/material';


import { useTranslation } from 'react-i18next';


import useUtils from 'library/utils';


ChartJS.register(ArcElement, Tooltip, Legend);



interface SalesPieChartProps {
  title: string,
  labels: string[];
  label: string,
  values: number[];
  backgroundColor?: string[];
  
}


export const SalesPieChart = ({ title, labels, label, values, backgroundColor}: SalesPieChartProps) => {

  const { t, i18n } = useTranslation();

  const {generatePastelColor} = useUtils();

  const computedBackgroundColors =
    backgroundColor && backgroundColor.length === values.length
      ? backgroundColor
      : values.map(() => generatePastelColor());

  const data = {
    labels: labels,
    datasets: [
      {
        label: label, // t('Sales'),
        data: values, //[8, 12, 3, 5],
        backgroundColor: computedBackgroundColors, //['#ff9800', '#4caf50', '#f44336', '#2196f3'],
        borderColor: ['#fff'],
        borderWidth: 0.5,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Pie data={data} options={options} />
      </CardContent>
    </Card>
  );
};
